module.exports = __webpack_public_path__ + "static/tyrant05-7202a933b3e644303c3b45db6903a366.png";